{
  "name": "reportsearch",
  "version": "1.10.0",
  "private": true,
  "dependencies": {
    "@azure/msal-browser": "catalog:",
    "@date-io/date-fns": "^1.3.13",
    "@material-ui/core": "^4.12.4",
    "@material-ui/icons": "^4.11.3",
    "@material-ui/lab": "^4.0.0-alpha.61",
    "@material-ui/pickers": "^3.3.10",
    "@types/bootstrap": "^4.5.1",
    "@types/history": "^4.7.11",
    "@types/jquery": "catalog:",
    "@types/lucene": "^2.1.2",
    "@types/react": "^17.0.0",
    "@types/react-dom": "^17.0.0",
    "@types/react-redux": "^7.1.11",
    "@types/react-router-dom": "^5.1.6",
    "@types/react-window": "^1.8.2",
    "@types/react-window-infinite-loader": "^1.0.9",
    "bootstrap": "catalog:",
    "date-fns": "^2.16.1",
    "history": "^4.10.1",
    "jquery": "catalog:",
    "jquery-resizable-dom": "^0.35.0",
    "lucene": "^2.1.1",
    "react": "^17.0.1",
    "react-dom": "^17.0.1",
    "react-redux": "^7.2.2",
    "react-router-dom": "^5.2.0",
    "react-window": "^1.8.6",
    "react-window-infinite-loader": "^1.0.7",
    "redux": "catalog:",
    "redux-devtools-extension": "^2.13.8",
    "redux-saga": "^1.1.3",
    "redux-thunk": "^2.3.0",
    "typed-redux-saga": "^1.3.1"
  },
  "scripts": {
    "start": "vite",
    "build": "vite build",
    "preview": "vite preview",
    "test": "vitest run",
    "test:watch": "vitest",
    "typecheck": "tsc --noEmit"
  },
  "devDependencies": {
    "@playwright/test": "catalog:",
    "@testing-library/jest-dom": "catalog:",
    "@testing-library/react": "^12.1.5",
    "@types/node": "catalog:",
    "@vitejs/plugin-react": "catalog:",
    "jsdom": "catalog:",
    "typescript": "catalog:",
    "vite": "catalog:",
    "vitest": "catalog:"
  }
}
